// Tela inicial do totem (welcome): mídias no fundo e o botão pulsando (verbatim).
import TotemFundoMidias from "../TotemFundoMidias";

export default function TelaInicial({ ctx }) {
  const { setScreen, telaCls, temMidia, setTemMidia, resetTotem, setAutoAtendimento, navigate, companyLogo, setEtapaIdent } = ctx;
  return (
    <div onClick={() => { setEtapaIdent("pergunta"); setScreen("identificacao"); }} data-e2e="totem-welcome" data-tem-midia={temMidia ? "1" : "0"} className={`${telaCls} bg-zinc-950 flex flex-col select-none cursor-pointer overflow-hidden`}>
      {/* Hidden back to admin button */}
      <div onClick={(e) => { e.stopPropagation(); if (setAutoAtendimento) { setAutoAtendimento(false); resetTotem(); } else { navigate('/'); } }} className="absolute top-0 left-0 w-16 h-16 z-20" />
      {/* Mídias de marketing (Cardápio → Banners → Totem) em loop no fundo. Com
          mídia, a tela fica só com ela e o botão embaixo — logo, título e
          subtítulo somem pra não brigar com a arte. */}
      <TotemFundoMidias ativo onMudou={(n) => setTemMidia(n > 0)} />
      {!temMidia && (
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-[-20%] left-[-10%] w-[60vw] h-[60vw] rounded-full bg-primary/10 blur-3xl animate-pulse" style={{ animationDuration: '4s' }} />
          <div className="absolute bottom-[-15%] right-[-10%] w-[50vw] h-[50vw] rounded-full bg-primary/10 blur-3xl animate-pulse" style={{ animationDuration: '6s', animationDelay: '1s' }} />
        </div>
      )}
      <style>{`
        @keyframes totem-cta-pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.06); }
        }
      `}</style>

      {/* Conteúdo central — só sem mídia */}
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center text-center px-8">
        {!temMidia && (
          <div className="max-w-2xl mx-auto" data-e2e="totem-welcome-texto">
            {companyLogo ? (
              <div className="mb-6 flex items-center justify-center">
                <img src={companyLogo} alt="Logo" className="w-28 h-28 md:w-36 md:h-36 lg:w-44 lg:h-44 object-contain drop-shadow-2xl" onError={(e) => { e.target.style.display = 'none'; }} />
              </div>
            ) : null}
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-primary drop-shadow-2xl leading-tight mb-4">
              Faça seu Pedido!
            </h1>
            <p className="text-xl md:text-2xl lg:text-3xl text-zinc-300 font-medium">
              Rápido, fácil e sem fila
            </p>
          </div>
        )}
      </div>

      {/* Botão embaixo, pulsando devagar (1,6 s) */}
      <div className="relative z-10 pb-10 md:pb-14 flex flex-col items-center gap-5 px-6">
        <div className="relative" style={{ animation: 'totem-cta-pulse 1.6s ease-in-out infinite' }} data-e2e="totem-cta">
          <div className="absolute inset-0 bg-primary rounded-full blur-xl opacity-50" />
          <div className="relative px-16 md:px-20 py-6 md:py-8 bg-primary text-primary-foreground text-2xl md:text-3xl lg:text-4xl font-black rounded-full shadow-2xl">
            TOQUE PARA COMEÇAR
          </div>
        </div>
        {!temMidia && (
          <p className="text-zinc-400 text-sm md:text-base">Toque em qualquer lugar da tela</p>
        )}
      </div>
    </div>
  );
}
